import { CONTENT_CLASSES } from "../content/content.constants";

export const getClosestNoteElement = (element) => {
  if (!element) {
    return null;
  }

  const nonTextNode = element.nodeType === Node.TEXT_NODE
    ? element.parentElement
    : element;

  const { classList } = nonTextNode;
  const { FOOT_NOTE, CHAPTER_END_NOTE, BOOK_END_NOTE } = CONTENT_CLASSES;
  return (
    classList.contains(FOOT_NOTE) ||
    classList.contains(CHAPTER_END_NOTE) ||
    classList.contains(BOOK_END_NOTE)
  ) ? nonTextNode : nonTextNode.closest(`.${FOOT_NOTE},.${CHAPTER_END_NOTE},.${BOOK_END_NOTE}`);
};

export const highlightContainingMarkNoteElements = (elContainer) => {
  if (elContainer) {
    const { FOOT_NOTE, CHAPTER_END_NOTE, BOOK_END_NOTE } = CONTENT_CLASSES;

    const elements = elContainer.querySelectorAll(
      `a.${FOOT_NOTE},a.${CHAPTER_END_NOTE},a.${BOOK_END_NOTE}`
    );

    for (const element of elements) {
      if (element.querySelector("mark")) {
        const elementMarkWrapped = document.createElement("mark");

        elementMarkWrapped.appendChild(element.cloneNode(true));

        if (element.parentNode) {
          element.parentNode.replaceChild(elementMarkWrapped, element);
        }
      }
    }
  }
};
